import {Injectable} from '@angular/core';
import {ToastrService} from "ngx-toastr";
import {UserService} from "../core/user/user.service";
import Bugsnag from '@bugsnag/js'

@Injectable({
  providedIn: 'root'
})
export class UrlService {

  constructor(
    private toastr: ToastrService,
    public userService: UserService,
  ) {
  }

  public buildRedirectUrl(urlToParse): string {

    var uriSearch = this.userService.user$.value.extProfiles; // URI.search(true);
    // console.log('uriSearch', uriSearch);

    //
    // Vérif qu'on a ce qu'il faut
    //
    var tags = urlToParse.match(/{{\s*[\w\.]+\s*}}/g)?.map(function (x) {
      return x.match(/[\w\.]+/)[0];
    });

    if (tags) {
      if (tags.length > 0) {
        var missingTags = [];

        tags.forEach(function (t) {
          if (!uriSearch[t]) {
            missingTags.push(t);
          }
        });

        if (missingTags.length > 0) {
          const errorMsg = missingTags.join('<br>') + ' tags are missing in URL...' + `Url: ${urlToParse}`
          Bugsnag.notify(new Error(errorMsg + `Url: ${urlToParse}`), (event) => {
            event.addMetadata('Url Service', {
              message: errorMsg
            })
          })
          console.warn(errorMsg)
        }

      }
    }

    return this.interpolate(urlToParse)(uriSearch);

  }

  public interpolate(str) {
    return function interpolate(o) {
      return str.replace(/{{([^{}]*)}}/g, function (a, b) {
        var r = o[b];
        return typeof r === 'string' || typeof r === 'number' ? r : a;
      });
    }
  }


}
